<template>
  <div>
    <!-- 订单列表 -->
    <div class="table-list bg-white mb15 border-radius-4" v-for="(order,i) in dataList" :key="i">
      <div class="ptb18 plr20 border-b">
        <p class="ft12">
          <span class="c333 mr30 ft14"><span class="iconfont iconhuowuleixing-icon ft16 cmain mr8"></span>业务类型：<span class="cmain">{{ order.Job_TypeName || '--' }}</span></span>
          <template v-if="jobType === '国际空运'">
            <span class="c888 mr30">主单号：<span class="">{{ order.MblNo || '--' }}</span></span>
            <span class="c888 mr30">分单号：<span class="">{{ order.HblNo || '--' }}</span></span>
            <span class="c888 mr30">客户编号：<span class="">{{ order.CusNo || '--' }}</span></span>
          </template>
          <span class="c888 mr30">业务编号：<span class="">{{ order.BookingNo || '--' }}</span></span>
          <template v-if="jobType === '国际海运'">
            <span class="c888 mr30">提单号：<span class="">{{ order.MblNo || '--' }}</span>
              <!-- <span class="iconfont iconwenjianxiazai ft14 cmain ml5"></span> -->
            </span>
            <span class="c888 mr30">进仓编号：<span class="">{{ order.InBoxNo || '--' }}</span>
              <!-- <span class="iconfont iconchakan3 ft14 cmain ml5"></span> -->
            </span>
            <span class="c888 mr30">客服：<span class="">{{ order.OPName || '--' }}</span></span>
            <span class="c888">操作部门：<span class=""><Ellipsis :length="15" tooltip>{{ order.DeptName || '--' }}</Ellipsis></span></span>
          </template>
        </p>
      </div>
      <div class="table-cont plr20 ptb15">
        <a-row class="flex">
          <div style="width:28%;" >
            <p class="ft12 c999 mb15">起运港：</p>
            <div class="flex flex-acenter flex-justify mb10">
              <span class="ft16 fw700 nowarp" :title="order.PolName" style="width:50%;">{{ order.PolName || '--' }}</span>
              <div class="flex flex-jcenter" style="flex:1;">
                <div v-for="item in 4" :key="item" class="whipptree_item bg-main mlr4"></div>
              </div>
            </div>
            <p class="ft12 c666 mb10"><span class="mr8">预计开航日期:</span><span>{{ order.ETD ? dateToString(order.ETD, 2) : '--' }}</span></p>
            <p class="ft12 cmain"><span class="mr8">实际开航日期:</span><span>{{ order.ATD ? dateToString(order.ATD, 2) : '--' }}</span></p>
          </div>
          <div style="width:18%;">
            <p class="ft12 c999 mb15">目的港：</p>
            <p class="ft16 fw700 mb10 nowarp pr20" :title="order.PodName">{{ order.PodName || '--' }}</p>
            <p class="ft12 c666 mb10"><span class="mr8">预计到港日期:</span><span>{{ order.ETA ? dateToString(order.ETA, 2) : '--' }}</span></p>
            <p class="ft12 cmain"><span class="mr8">实际到港日期:</span><span>{{ order.ATA ? dateToString(order.ATA, 2) : '--' }}</span></p>
          </div>
          <div style="min-width:12%;flex:1;" class="pl15">
            <p class="ft12 c999 mb15">是否危险品：</p>
            <p class="ft14 c33">{{ order.IsDanger === 'Y' ? '是' : '否' }}</p>
          </div>
          <div style="min-width:12%;flex:1;" v-if="jobType!=='国际空运'" class="pl15">
            <p class="ft12 c999 mb15">箱型箱量：</p>
            <p class="ft14 c33">{{ order.ContainerType || '--' }}</p>
          </div>
          <div style="min-width:10%;flex:1;" class="pl15">
            <p class="ft12 c999 mb15">毛重(KG)：</p>
            <p class="ft14 c33">{{ order.GW || '--' }}</p>
          </div>
          <div style="min-width:10%;flex:1;" class="pl15">
            <p class="ft12 c999 mb15">体积(m³)：</p>
            <p class="ft14 c33">{{ order.CBM || '--' }}</p>
          </div>
          <div style="min-width:10%;flex:1;" v-if="jobType!=='国际空运'" class="pl15">
            <p class="ft12 c999 mb15">码头放行：</p>
            <p class="ft14 c33">{{ order.WharfReleaseSign==='Y' ? '是' : (order.WharfReleaseSign==='N'?'否':'--') }}
              <!-- <span class="iconfont iconwenjianxiazai ft14 cmain ml5"></span> -->
            </p>
          </div>
        </a-row>
        <a-collapse :bordered="false" class="wuliu-collapse" @change="collapseChange(i)">
          <a-collapse-panel
            key="1"
            :show-arrow="false"
            :destroyInactivePanel="true"
            :forceRender="false"
            style="border:0;"
          >
            <div slot="header">{{ List[i]?'收起':'物流详情' }}</div>
            <LogisticsNode :ref="'logisticsNode'+i" :nodesData="order" />
          </a-collapse-panel>
        </a-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import LogisticsNode from './LogisticsNodes'
import { dateToString } from '@/utils/date-formatter'
import { Ellipsis } from '@/components'
export default {
  name: 'TableList',
  components: { LogisticsNode, Ellipsis },
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    jobType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      List: []
    }
  },
  mounted () {
    this.List.length = this.dataList.length
  },
  methods: {
    dateToString,
    collapseChange (index) {
      this.List[index] = !this.List[index]
      this.List = JSON.parse(JSON.stringify(this.List))
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../../styles/var.less';
.whipptree_item {
  width: 14px;
  height: 2px;
  transform: skewX(60deg);
}
.wuliu-collapse {
  background-color: #fff;
  /deep/ .ant-collapse-item {
    position: relative;
    .ant-collapse-header {
      position: absolute;
      right: 10px;
      top: -20px;
      width: 70px;
      padding: 0;
      text-align: right;
      color: @main-color;
    }
    .ant-collapse-content-box {
      padding: 0;
    }
  }
}
.nowarp {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
